<template>
    <svg class="spinner" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
        <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" class="spinner-bg"/>
        <path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="spinner-inner"/>
    </svg>
</template>
<style lang="scss">
@import '../Styles/variables';

.spinner {
    .spinner-bg {
        fill: var(--gray-400, map-get($yapla-gray, 400)) !important;
    }

    .spinner-inner {
        transform-origin: center;
        animation: rotate .75s infinite linear
    }
    @keyframes rotate{
        100% {
            transform: rotate(360deg)
        }
    }
}

</style>